<body class="bg-gradient-primary">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</body>
  
  